module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/lpo_features_01-236f0849a5ff0f169217d2dc21782b67.png";